/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';
import { IAttrStyled } from '../../../../types/globalTypes';

export const SubscriberIdErrorStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `subscriber-id-error ${className || ''}`,
}))<IAttrStyled>`
    display: flex;
    flex-direction: column;

    &.subscriber-id-error_left {
        align-items: flex-start;
    }

    &.subscriber-id-error_center {
        align-items: center;
    }

    .subscriber-id-error__title {
        ${fonts.textMainBold};
        margin: 12px 0;
    }
`;
